import { render, staticRenderFns } from "./marking.vue?vue&type=template&id=07ee05aa"
import script from "./marking.vue?vue&type=script&lang=ts"
export * from "./marking.vue?vue&type=script&lang=ts"
import style0 from "./marking.vue?vue&type=style&index=0&id=07ee05aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports